import React, {ReactNode} from 'react';
import {useDialogContext} from 'components/dialog/DialogContext';
import {useResourceContext} from 'components/record/ResourceContext';
import {useRecordContext} from 'components/record/useRecordContext';
import {SubmitHandler} from 'react-hook-form';
import {toast} from 'react-toastify';
import {FormContainer} from 'react-hook-form-mui';
import {useDataProvider} from 'provider/DataProvider';
import {transformDatesAndRelations} from 'services/utils';

const EditDialogBody = ({children, onSuccess}: {children: ReactNode; onSuccess?: () => void}) => {
  const {resource} = useResourceContext();
  const dataProvider = useDataProvider();
  const {close} = useDialogContext();
  const {record, id} = useRecordContext();

  const defaults = React.useMemo(() => transformDatesAndRelations(record, resource), [record]);

  const handleEdit: SubmitHandler<React.FormEvent<HTMLFormElement>> = (payload) => {
    dataProvider
      .updateResource(resource, id, payload)
      .then((res) => {
        if (res.data) {
          const itemName = res.data.name || res.data.id ? ` ${res.data.name || res.data.id}` : '';
          toast.success(`${resource}${itemName} has been updated successfully!`);
          if (onSuccess && typeof onSuccess === 'function') {
            onSuccess();
          }
          close();
        }
      })
      .catch((error) => {
        if (error.message) {
          toast.error(error.message);
        }
      });
  };

  return (
    <FormContainer FormProps={{id: `edit_${resource}`, noValidate: true}} defaultValues={defaults} onSuccess={handleEdit}>
      {children}
    </FormContainer>
  );
};

export default EditDialogBody;
